import { Component, Injector, Type } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService } from '@services/events.service';
import { LoadingService } from '@services/loading.service';
import { StorageService } from '@services/storage.service';
import { ToastService } from '@services/toast.service';
import { ServiceLocator } from '@app/app.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-base',
	template: ''
})
export class BasePage {
	protected loadingService: LoadingService;
	protected toastService: ToastService;
	protected storageService: StorageService;
	protected eventsService: EventsService;
	protected translateService: TranslateService;
	protected router: Router;
	language: string = 'pt';

	constructor() {
		const injector: Injector = ServiceLocator.injector;
		this.router = injector.get<Router>(Router as Type<Router>);
		this.eventsService = injector.get<EventsService>(EventsService as Type<EventsService>);
		this.loadingService = injector.get<LoadingService>(LoadingService as Type<LoadingService>);
		this.storageService = injector.get<StorageService>(StorageService as Type<StorageService>);
		this.toastService = injector.get<ToastService>(ToastService as Type<ToastService>);
		this.translateService = injector.get<TranslateService>(TranslateService as Type<TranslateService>);

		this.getLanguage();
	}

	translate(word: string) {
		return this.translateService.instant(word);
	}

	getLanguage() {
		this.language = this.translateService.defaultLang;
	}

	changeLanguage(lang: string) {
		this.language = lang;
		this.translateService.setDefaultLang(lang);
		this.storageService.set('language', lang);
		this.eventsService.publish('update:language', lang);
	}
}
